<template>
  <v-container>
    <h2 class="font-weight-light mb-2">Recommended Gear</h2>
    <v-row no-gutters>
      <v-col
        v-for="recommendation in recommendations"
        :key="recommendation.slug"
        md="3"
        sm="6"
      >
        <LegacyGearCard :gear="recommendation" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LegacyGearCard from '@/components/gear/LegacyGearCard'

export default {
  name: 'RecommendedGear',
  components: {
    LegacyGearCard,
  },
  props: {
    activity: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    recommendations: [],
  }),
  mounted() {
    const url = `/api/v2/gearRecommendations/?slug=${this.activity.slug}`
    this.$axios.get(url).then((response) => {
      this.recommendations = response.data.recommendations
    })
  },
}
</script>
